<template>
  <div class="">
    <h2 class="h3 bold mb3">Bitte bestätige deinen Kommentar mit deiner SMS-PIN</h2>
    <div class="mb2 relative">
      <input class="n8-input" v-model="pin" required :class="{ error: not_filled_pin }">
      <span class="floating-label">Deine PIN</span>
    </div>
    <p style="color: red;" v-if="not_filled_pin">Bitte gib eine PIN ein.</p>
    <p style="color: red;" v-if="not_correct_pin">Die eingegebene PIN ist nicht korrekt.</p>
    <div class="mt3">
    <button class="btn btn-primary mb3" @click="validateInput()">Absenden</button>
    <p>Keine Pin erhalten? <span class="underlined pointer color-gray" @click="revalidate()">SMS erneut senden</span></p>
    <p class="mt2 color-primary" v-if="revalidation_sent">Eine SMS mit deiner neuen PIN wurde an deine Handynummer verschickt!</p>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import axios from 'axios';

export default {
  name: 'SMSChecker',
  data() {
    return {
      session: {},
      pin: '',
      not_filled_pin: false,
      not_correct_pin: false,
      revalidation_sent: false,
      allIsValidated: true,
    }
  },
  props: {
    phone_nr: String,
    user_name: String,
    dsgvo: Boolean,
    checkerParent: String,
    success: String
  },
  created(){
    EventBus.$on('sendSession', (payload) => {
      console.log('Sesssion Transmitted')
      this.session = payload.session;
    })
    EventBus.$on('sendSession_not_validated', (payload) => {
      console.log('received data from componente not validated')
      this.session.validation_crypt = payload.validation_crypt;
      this.session.validation_id = payload.validation_id;
      this.session.validation_object = payload.validation_object;
    })
  },
  // beforeDestroy(){
  //   EventBus.$off('requestSession');
  // },
  methods:{
    validateInput(){
        this.allIsValidated = true;
        this.not_filled_pin = false;
        this.not_correct_pin = false;

        if(this.pin == ''){
            this.allIsValidated = false;
            this.not_filled_pin= true;
        }
        if(this.allIsValidated == true){
              //send form data
            let url =  'https://bilder.nachtschicht-schortens.de/public-api/do-validation/json';
            let data = {};
            data.pin = this.pin;
            data.validation_id = this.session.validation_id;
            data.validation_crypt = this.session.validation_crypt;
            data.validation_object= this.session.validation_object;
            // data.name = this.user_name;
            axios.post(url, data)
              .then(response => { 
                console.log('SMSCHecker Response: ')
                console.log(response)
                if(response.data.validationOkay == true){
                  console.log('SMS Validation Successfull')
                  console.log('Sending Session to App')
                  EventBus.$emit('send_validation', {
                    'validation_crypt': this.session.validation_crypt,
                    'validation_id': this.session.validation_id, 
                    'validation_object': this.session.validation_object 
                  });
                  console.log('Sending User to App')
                  EventBus.$emit('send_user', {
                    'user_name': this.user_name,
                    'phone_nr': this.phone_nr,
                    'dsgvo': this.dsgvo
                  });

                  this.session = response.data;
                  EventBus.$emit('close_' + this.checkerParent + '_lightbox');
                  EventBus.$emit('show_' + this.success + '_sent_lightbox');
                  EventBus.$emit('clear_' + this.success);
                  if(this.success == 'comment'){
                    EventBus.$emit('reload_comments');
                  }
                }else{
                  console.log('SMS Validation not Successfull')
                  this.not_correct_pin = true;
                }
              })
              .catch(function (error) {
                  console.log(error)
              });
        } 
      },
    revalidate(){
      this.revalidation_sent = false;
      let url =  'https://bilder.nachtschicht-schortens.de/public-api/revalidate/json';
      let data = {};
      data.mobilephone = this.phone_nr;
      data.name = this.user_name;
      data.validation_id = this.validation_id;
      data.validation_crypt = this.validation_crypt;
      data.name = this.user_name;
      axios.post(url, data)
        .then(response => { 
          this.revalidation_sent = true;
          // console.log('Revalidating. Sending new Sesssion to App')
          console.log(response);
          this.session.validation_crypt = response.data.validation_crypt;
          this.session.validation_id = response.data.validation_id;
          this.session.validation_object = response.data.validation_object;


          this.session = response.data;
        })
        .catch(function (error) {
            console.log(error)
        });
    }
    }
  }

</script>

<style scoped>

</style>